
export const MenuRoles = {
   DASHBOARD: {
       roleName: "DASHBOARD", 
       defaultRoute: '/dashboard'
   },
   ALL_TRANSACTIONS: {
      roleName: "ALL_TRANSACTIONS",
      defaultRoute: '/transactions'
   },
   EXCHANGE_SERVICE: {
      roleName: "EXCHANGE_SERVICE",
      defaultRoute: '/exchange'
   },
   CRYPTO_SERVICE: {
      roleName: "CRYPTO_SERVICE",
      defaultRoute: '/coinapi'
   },
   USERS: {
      roleName: "USERS",
      defaultRoute: '/users'
   },
   KYC: {
      roleName: "KYC",
      defaultRoute: '/kyc'
   },
   SETTINGS: {
      roleName: "SETTINGS",
      defaultRoute: '/settings'
   },
   CRYPTO_OUT: {
      roleName: "CRYPTO_OUT",
      defaultRoute: '/cryptoout'
   },
   BANK_IN_OUT: {
      roleName: "BANK_IN_OUT",
      defaultRoute: '/bankinout'
   },
   CLIENTS: {
      roleName: "CLIENTS",
      defaultRoute: '/private'
   },
   TICKETS: {
      roleName: "TICKETS",
      defaultRoute: '/tickets'
   },
   STATISTICS: {
      roleName: "STATISTICS",
      defaultRoute: '/statistics'
   },
   KYC_MEETINGS: {
      roleName: "KYC_MEETINGS",
      defaultRoute: '/calendar'
   },
   BALANCE: {
      roleName: "BALANCE",
      defaultRoute: '/balance'
   }
};